import { render, staticRenderFns } from "./CoreSwiper.vue?vue&type=template&id=563a11b8&scoped=true&"
import script from "./CoreSwiper.vue?vue&type=script&lang=ts&setup=true&"
export * from "./CoreSwiper.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./CoreSwiper.vue?vue&type=style&index=0&id=563a11b8&lang=scss&"
import style1 from "./CoreSwiper.vue?vue&type=style&index=1&id=563a11b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563a11b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('563a11b8')) {
      api.createRecord('563a11b8', component.options)
    } else {
      api.reload('563a11b8', component.options)
    }
    module.hot.accept("./CoreSwiper.vue?vue&type=template&id=563a11b8&scoped=true&", function () {
      api.rerender('563a11b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/core/CoreSwiper/CoreSwiper.vue"
export default component.exports